import { Component } from '@angular/core';
import { faUserClock } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { BrickCategory } from 'src/app/samwebDescription/samweb/brickCategoryType';
import { PresenceDurationBrickSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/presence-duration-brick-settings/presence-duration-brick-settings.state';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { PresenceDurationBrickSettingsComponent } from './presence-duration-brick-settings/presence-duration-brick-settings/presence-duration-brick-settings.component';
import { PresenceDurationBrickBaseComponent } from './presence-duration-brick.base.component';
import { PresenceDurationBrickSmallComponent } from './presence-duration-brick.small.component';

@Component({
   selector: 'samweb-presence-duration-brick',
   templateUrl: './presence-duration-brick.default.component.html',
   styleUrls: ['./presence-duration-brick.default.component.scss'],
})
@SamwebBrick({
   brickDefinitionId: 'presenceDuration',
   brickTitleTranslationKey: 'brick.brick_definitions.presence_duration.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.presence_duration.description',
   brickIcon: faUserClock,
   minColWidth: 10,
   minRowHeight: 3,
   brickCategory: BrickCategory.GENERAL,
   settingsComponent: PresenceDurationBrickSettingsComponent,
   settingStateHandler: PresenceDurationBrickSettingsState,
   smallBrickComponentAlternative: PresenceDurationBrickSmallComponent,
   requiresActiveCoreConnection: true,
})
export class PresenceDurationBrickDefaultComponent extends PresenceDurationBrickBaseComponent {
   constructor(store: Store) {
      super(store);
   }

   isSmallView = false;
}
